import { REDUCER_NAME } from './const'

export const selectOwnState = state => {
    return state[REDUCER_NAME]
}



// WEBPACK FOOTER //
// ./src/modules/treatment/state/selector.js